import {Button, ButtonProps, CircularProgress} from "@mui/material";
import React, {useMemo} from "react";
import {useFollowVessel} from "~/apps/packages/vessel-calls/hooks";
import {Star, StarOutlined} from "~/ui/icons";


export type VesselFavoriteButtonProps = ButtonProps & {
    imo: string
    favorite: boolean
}

export const VesselFavoriteButton = (props: VesselFavoriteButtonProps) => {
    const {imo, favorite, ...other} = props;
    const {follow, unfollow, loading} = useFollowVessel(imo);
    const icon = useMemo(() => {
        if (loading) {
            return <CircularProgress size="small"/>;
        }
        return favorite ? <Star style={{ fontSize: 24 }} /> : <StarOutlined style={{ fontSize: 24, fill: 'none' }} />;
    }, [loading, favorite])

    const handleClick = () => {
        if (loading) {
            return;
        }
        if (favorite) {
            unfollow();
        } else {
            follow();
        }
    }

    return (
        <Button
            {...other}
            startIcon={icon}
            color={favorite ? "secondary" : "primary"}
            disabled={loading}
            onClick={handleClick}
        >

            {favorite ? "Не отслеживать судно" : "Отслеживать судно"}
        </Button>
    )
}
